export default __webpack_public_path__ + "static/media/Casinoverse.25afb021.png";